import { CR_API_ENDPOINTS } from '../constants';
import { ReroofStatus } from '../types';
import { apiService } from './api.service';

class ReroofStatusService {
  async getAllReroofStatuses(): Promise<ReroofStatus[]> {
    return apiService.get<ReroofStatus[]>(CR_API_ENDPOINTS.REROOF_STATUS);
  }

  async getReroofStatusById(id: string): Promise<ReroofStatus> {
    return apiService.get<ReroofStatus>(`${CR_API_ENDPOINTS.REROOF_STATUS}/${id}`);
  }

  async createReroofStatus(reroofStatusData: {
    value: string;
  }): Promise<ReroofStatus> {
    try {
      return await apiService.post<ReroofStatus>(CR_API_ENDPOINTS.REROOF_STATUS, reroofStatusData);
    } catch (error) {
      throw new Error(`Failed to create reroof status: ${error}`);
    }
  }
}

export const reroofStatusService = new ReroofStatusService();